import { FC } from "react";

interface Props {}

// eslint-disable-next-line
const PageNotFound: FC<Props> = () => <>Page Not Found</>;

export default PageNotFound;
